const subscriptions = new Map();

export const subscribe = (key:string, callback:Function) => {
  if (!subscriptions.has(key)) {
    subscriptions.set(key, []);
  }
  subscriptions.get(key).push(callback);
};

export const notify = (key:string, value:any) => {
  if (subscriptions.has(key)) {
    for (const callback of subscriptions.get(key)) {
      callback(value);
    }
  }
};